import React, { Component } from 'react'
import * as Func from '../../../../../../../../../helpers/functions';
import EllipsisText from '../../../../../../../common/component/EllipsisText';
import { Tooltip, Menu, Icon, Dropdown, Modal, message, List, Checkbox } from 'antd';
import { ListComponent, FormActionComponent, FormWrapperInputComponent } from '../../../../../../../common/component/Index';
import Wrapper from '../../../../../../../common/component/Wrapper';
import { withTranslation } from 'react-i18next';
import AntSelect, { AntOption } from '../../../../../../../common/component/AntSelect';
import Ripple from '../../../../../../../common/component/Ripple';
import { get, uniq, difference, uniqBy } from 'lodash';
import './TourLineTicket.less';

const ListCols = ['ticketName', 'ticketType', 'soldQuantity']
const ModelFields = ListCols

class TourLineTicket extends Component {
    constructor(props) {
        super(props);
        const { t } = this.props;
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, [], []),
            modelItem: ModelFields,
            componentTable: {
                ticketName: {
                    key: 'ticketName',
                    render: (text, record) =>
                        <EllipsisText
                            title={ { ...this.props.tourTicket.allTourTickets.find(item => item.id === record.ticketId) }?.name || record.tourTicket?.name }
                            content={ { ...this.props.tourTicket.allTourTickets.find(item => item.id === record.ticketId) }?.name || record.tourTicket?.name }
                            contentMaxWidth={ 300 }
                            overlayClassName={ 'max-width-500' }
                            overlayComponent={ Tooltip }/>
                },
                ticketType: {
                    key: 'ticketType',
                    render: (text, record) =>
                        <List size="small"
                              dataSource={ record?.tourTicketItems }
                              renderItem={ item =>
                                  <List.Item
                                    //   actions={ [<Icon type="delete" className="fs18 cursorPointer" onClick={ () => this.removeItemTicketDetail(record.tourTicket?.id, item) }/>] }
                                  >
                                      { `${ item?.code } - ${ item?.objectType?.name } - ${ item?.salePrice.toLocaleString() } ${ t(`currency`) }` }
                                  </List.Item>
                              }
                        />
                },
                soldQuantity: {
                    key: 'soldQuantity',
                    render: (text, record) =>
                        <List size="small"
                              dataSource={ record?.tourTicketItems }
                              renderItem={ item =>
                                  <List.Item
                                      actions={ [<Icon type="delete" className="fs18 cursorPointer" onClick={ () => this.removeItemTicketDetail(record.tourTicket?.id, item) }/>] }
                                  >
                                      { item?.soldQuantity }
                                  </List.Item>
                              }
                        />
                },
            },
            openDetail: false,
            detailTicket: {
                tourItemId: null,
                tourItemIds: [],
                tourLineItemId: null,
                tourTicketItemIds: [],
            },
            isEdit: false,
            validation: {},
            listTickets: [],
            listInitTickets: [],
            iSelected: null,
            listTourTicketItems: [],
            ticketsWithoutTourLineId: [],
            itemIds: []
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.tourTicket.allTourTicketsByIds !== prevProps.tourTicket.allTourTicketsByIds) {
            const { tourTicket, tickets } = this.props;
            const { allTourTicketsByIds } = tourTicket;
            let newAllTourTicketsByIds = allTourTicketsByIds;
            this.setState({
                listTickets: newAllTourTicketsByIds,
            })
        }
    }

    componentWillMount() {
        const { getAllTicketsById, tourState } = this.props;
        this.setState({ listInitTickets: [] })
        this.props.onInitTickets([])
        const tourId = get(tourState, 'detail.tour.id');
        getAllTicketsById && getAllTicketsById(tourId);
    }

    removeItemTicketDetail(tourTicketId, item) {
        const { deleteItemTicketDetail, t, tourLineId } = this.props;
        const { confirm } = Modal;
        confirm({
            title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.tour.ticketType`)),
            okText: t(`action.remove`),
            cancelText: t(`action.cancel`),
            onOk: () => {
                if (!tourLineId) {
                    this.removeInitTicket(tourTicketId, item);
                    return;
                }
                deleteItemTicketDetail && deleteItemTicketDetail({ ...item, tourLineItemId: tourLineId });
            },
        });
    }

    onChangeTicketObjectType(id, checked) {
        let { detailTicket } = this.state;
        let tourTicketItemIds = detailTicket.tourTicketItemIds;
        const existedTourTicketItem = tourTicketItemIds.filter(item => {
            return item === id
        });
        if (checked) {
            if (existedTourTicketItem.length <= 0) {
                tourTicketItemIds.push(id);
            }
        } else {
            // tourTicketItemIds = existedTourTicketItem;
            tourTicketItemIds = tourTicketItemIds.filter(item => {
                return item !== id
            });
        }
        detailTicket = {
            ...detailTicket,
            tourTicketItemIds: tourTicketItemIds,
        }
        this.setState({ detailTicket });
    }

    render() {
        const { tickets, t, tourLineId, allowUpdateContent } = this.props
        const { titleItemTable, componentTable, detailTicket, validation, isEdit, openDetail, listTickets, ticketsWithoutTourLineId } = this.state;
        const selectedTourTickets = this.getSelectedTourTickets();
        return (
            <Wrapper>
                <ListComponent
                    tableKey="tour-list"
                    classParent="tour-list m-0"
                    classChildren="p-0"
                    rowKey={ (record, k) => record.id ? record.id : k }
                    dataSource={ tourLineId ? tickets : ticketsWithoutTourLineId }
                    columns={ Func.columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'tour'
                    }) }
                    componentTableList={ {} }
                />
                <div className="add-tour-line-ticket mt-10">
                    <Ripple
                        color="white"
                        className="btn btn-primary ml-2"
                        disabled={ !allowUpdateContent }
                        onClick={ () => this.setState({ openDetail: true }) }>
                        { t('item.tour.createTicket') }
                    </Ripple>
                </div>
                <Modal
                    title={ t(`item.tour.${ isEdit ? 'updateTicket' : 'createTicket' }`) }
                    visible={ this.state.openDetail }
                    maskClosable={ false }
                    onOk={ this.handleOk }
                    onCancel={ this.closeModal }
                    okButtonProps={ { disabled: detailTicket.tourTicketItemIds.length <= 0 } }
                >
                    { openDetail &&
                    <Wrapper className="col-md-12">
                        <FormActionComponent
                            disabledFooter
                        >
                            <Wrapper className='col-md-12 basic-section'>
                                <FormWrapperInputComponent
                                    isRequired={ true }
                                    isValidation={ true }
                                    dataValidation={ detailTicket.tourItemIds }
                                    validation={ validation.tourItemIds }
                                    labelTitle={ t(`item.tour.ticketName`) }
                                >
                                    <AntSelect className="select-site-code"
                                               mode="multiple"
                                               showArrow showSearch
                                               placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tour.ticketName")).toLowerCase()) }
                                               value={detailTicket.tourItemIds}
                                               onChange={ (e) => {
                                                    this.onChange('tourItemIds', e, true)
                                               } }
                                               style={ { width: '100%' } }
                                               filterOption={ this.selectFilterSearch }
                                    >
                                        { listTickets.map(item => (
                                            <AntOption 
                                                key={ item.id } 
                                                value={ item.id }
                                            >
                                                { `${ item.name }` }
                                            </AntOption>
                                        )) }
                                    </AntSelect>
                                </FormWrapperInputComponent>
                                { selectedTourTickets && selectedTourTickets.length > 0 &&
                                <FormWrapperInputComponent
                                    isRequired={ true }
                                    labelTitle={ t(`item.tour.ticketObjectType`) }
                                    isValidation={ true }
                                    dataValidation={ detailTicket.tourTicketItemIds }
                                    validation={ validation.tourTicketItemIds }
                                >
                                    <Wrapper className="tour-ticket-object-type-columns">
                                        { selectedTourTickets.map(ticket => {
                                            const disabledItemIds = this.getDisabledItemIds(ticket.id);
                                            return (
                                                <Wrapper className="tour-ticket-object-type-column" key={ ticket.id }>
                                                    <Wrapper className="tour-ticket-object-type-title">{ ticket.name }</Wrapper>
                                                    <List size="small"
                                                          dataSource={ ticket.tourTicketItems || [] }
                                                          renderItem={ item =>
                                                              <List.Item>
                                                                  <Checkbox className="ml-2"
                                                                        checked={ detailTicket.tourTicketItemIds.includes(item.id) }
                                                                        disabled={ disabledItemIds.includes(item.id) }
                                                                        onChange={ e => this.onChangeTicketObjectType(item.id, e.target.checked) }
                                                                  >
                                                                      { `${ item?.objectType?.name } - ${ item?.salePrice.toLocaleString() } ${ t(`currency`) }` }
                                                                  </Checkbox>
                                                              </List.Item>
                                                          }
                                                    />
                                                </Wrapper>
                                            )
                                        }) }
                                    </Wrapper>
                                </FormWrapperInputComponent>
                                }
                            </Wrapper>
                        </FormActionComponent>
                    </Wrapper>
                    }
                </Modal>
            </Wrapper>

        )
    }

    getSelectedTourTickets = () => {
        const { detailTicket, listTickets } = this.state;
        const tourItemIds = detailTicket.tourItemIds || [];
        return (listTickets || []).filter(item => tourItemIds.includes(item.id));
    }

    getDataTickets = () => {
        const { ticketsWithoutTourLineId } = this.state;
        const { tickets } = this.props;
        return ticketsWithoutTourLineId.length > 0 ? ticketsWithoutTourLineId : (tickets || []);
    }

    getDisabledItemIds = (tourItemId) => {
        const getTicketSelected = this.getDataTickets().find(ticket => ticket.tourTicket && ticket.tourTicket.id === tourItemId)
        if(!!getTicketSelected) {
            return (getTicketSelected.tourTicketItems || []).map(item => item.id)
        }
        return []
    }

    getTicketItemIdsByTicket = (detailTicket = this.state.detailTicket) => {
        const selectedTourTickets = this.getSelectedTourTickets();
        return selectedTourTickets.reduce((result, ticket) => {
            const ticketItemIds = (ticket.tourTicketItems || []).map(item => item.id);
            const selectedItemIds = (detailTicket.tourTicketItemIds || []).filter(id => ticketItemIds.includes(id));
            if (selectedItemIds.length > 0) {
                result[ticket.id] = selectedItemIds;
            }
            return result;
        }, {});
    }

    renderEditComponent(item, index) {
        const { t } = this.props;
        return (
            <Dropdown overlay={
                <Menu className="action-menu">
                    <Menu.Item onClick={ e => this.onEdit(item, index) }><Icon type="form" className="fs20 mr-1"/>{ t(`action.edit`) }</Menu.Item>
                    <Menu.Item onClick={ e => this.onRemove(item, index) }><Icon type="delete" className="fs20 mr-1"/>{ t(`action.remove`) }</Menu.Item>
                </Menu>
            }>
                <Icon type="more" className="fs20 cursorPointer"/>
            </Dropdown>
        )
    }

    // onRemove = (item, index) => {
    //     const { t, tourLineId } = this.props;
    //     const { confirm } = Modal;
    //     confirm({
    //         title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.tour.ticketName`)),
    //         okText: t(`action.remove`),
    //         cancelText: t(`action.cancel`),
    //         onOk: () => {
    //             if (!tourLineId) {
    //                 this.deleteInitTicket(index)
    //                 return
    //             }
    //             this.props.deleteItemTicketDetail && this.props.deleteItemTicketDetail(item);
    //         },
    //     });
    // }

    // onEdit = (item, index) => {
    //     const { tourLineId } = this.props
    //     const detailTicket = {
    //         id: item.id || undefined,
    //         ticketId: tourLineId ? item.ticketDetail.id : item.ticketId,
    //         adultOriginalPrice: tourLineId ? item.ticketPrice.adultOriginalPrice : item.adultOriginalPrice,
    //         adultSalePrice: tourLineId ? item.ticketPrice.adultSalePrice : item.adultSalePrice,
    //         childOriginalPrice: tourLineId ? item.ticketPrice.childOriginalPrice : item.childOriginalPrice,
    //         childSalePrice: tourLineId ? item.ticketPrice.childSalePrice : item.childSalePrice,
    //         infantOriginalPrice: tourLineId ? item.ticketPrice.infantOriginalPrice : item.infantOriginalPrice,
    //         infantSalePrice: tourLineId ? item.ticketPrice.infantSalePrice : item.infantSalePrice,
    //         currencyCode: tourLineId ? item.ticketPrice.currencyCode : item.currencyCode
    //     }
    //     this.setState({ openDetail: true, detailTicket, isEdit: true, iSelected: index })
    // }

    onChange = (fieldName, value, isDropDownTicket = true) => {
        const { detailTicket, listTickets } = this.state;
        let arrayNumber = ['adultOriginalPrice', 'adultSalePrice', 'childOriginalPrice', 'childSalePrice', 'infantOriginalPrice', 'infantSalePrice'];
        if (arrayNumber.includes(fieldName)) {
            detailTicket[fieldName] = Func.formatNumber(value) // add value type money
        } else if (fieldName === 'tourItemIds') {
            const tourItemIds = value || [];
            const selectedTickets = (listTickets || []).filter(item => tourItemIds.includes(item.id));
            const selectedTicketItemIds = selectedTickets.reduce((ids, item) => {
                return ids.concat((item.tourTicketItems || []).map(ticketItem => ticketItem.id));
            }, []);
            detailTicket.tourItemIds = tourItemIds;
            detailTicket.tourItemId = tourItemIds[0] || null;
            detailTicket.tourTicketItemIds = (detailTicket.tourTicketItemIds || []).filter(id => selectedTicketItemIds.includes(id));
        } else {
            detailTicket[fieldName] = value;
        }
        let listTourTicketItems = [];
        if (isDropDownTicket && listTickets && listTickets.length > 0) {
            const existedTicketItems = listTickets.filter(item => {
                return fieldName === 'tourItemIds' ? (value || []).includes(item.id) : item.id === value
            });
            if (existedTicketItems && existedTicketItems.length > 0) {
                listTourTicketItems = existedTicketItems.reduce((items, ticketItemsData) => {
                    return items.concat(ticketItemsData.tourTicketItems || []);
                }, []);
            }
        }
        this.setState({ detailTicket, listTourTicketItems });
    };

    handleOk = () => {
        const { detailTicket, isEdit } = this.state;
        const { createItemTicketDetail, updateItemTicketDetail, tourLineId } = this.props;
        
        detailTicket.tourLineItemId = tourLineId;
        if(this.validateObjectType()) {
            if (!isEdit) {
                if (!tourLineId) {
                    this.upsertInitTicket(detailTicket)
                    return
                }
                const ticketItemIdsByTicket = this.getTicketItemIdsByTicket(detailTicket);
                Object.keys(ticketItemIdsByTicket).forEach(tourItemId => {
                    createItemTicketDetail({
                        ...detailTicket,
                        tourItemId,
                        tourTicketItemIds: ticketItemIdsByTicket[tourItemId],
                    })
                })
            } else {
                if (!tourLineId) {
                    this.upsertInitTicket(detailTicket)
                    return
                }
                updateItemTicketDetail(detailTicket)
            }
            this.closeModal()
        }
    }

    validateObjectType = () => {
        const ticketItemIdsByTicket = this.getTicketItemIdsByTicket(this.state.detailTicket);
        const selectedTourTickets = this.getSelectedTourTickets();

        for (const tourItemId of Object.keys(ticketItemIdsByTicket)) {
            const selectedTicket = selectedTourTickets.find(item => item.id === tourItemId);
            const ticketSelected = ticketItemIdsByTicket[tourItemId].map(ticket => ((selectedTicket?.tourTicketItems || []).find(item => item.id === ticket)))
            const uniqSelectedTicket = uniqBy(ticketSelected, 'objectType.id')
            if(ticketSelected.length !== uniqSelectedTicket.length) {
                message.error('Đối tượng vé không được tạo trùng !')
                return false
            }

            const getTicket = this.getDataTickets().find(item => item.tourTicket && item.tourTicket.id === tourItemId)
            if(!!getTicket) {
                const mergeTicket = [...getTicket.tourTicketItems, ...ticketSelected]
                const uniqTicket = uniqBy(mergeTicket, 'objectType.id')
                if(mergeTicket.length !== uniqTicket.length) {
                    message.error('Đối tượng vé không được tạo trùng !')
                    return false
                }
            }
        }
        
        return true
    }

    removeInitTicket = (tourTicketId, delItem) => {
        if (tourTicketId && delItem) {
            let { ticketsWithoutTourLineId, listInitTickets  } = this.state;
            ticketsWithoutTourLineId = ticketsWithoutTourLineId.map(currentItemTicket => {
                if (currentItemTicket.tourTicket && currentItemTicket.tourTicket.id === tourTicketId) {
                    let tourTicketItems = currentItemTicket.tourTicketItems;
                    const afterFilterTourTicketDatas = tourTicketItems.filter(currentItem => {
                        return currentItem.id !== delItem.id;
                    })
                    currentItemTicket.tourTicketItems = [...afterFilterTourTicketDatas];
                    return currentItemTicket;
                }
                return currentItemTicket;
            })
            listInitTickets = listInitTickets.filter(initTicket => { return initTicket !== delItem.id });
            this.setState({ listInitTickets, ticketsWithoutTourLineId });
            this.props.onInitTickets(uniq(listInitTickets));
        }
    }

    upsertInitTicket = (detailTicket) => {
        const ticketItemIdsByTicket = this.getTicketItemIdsByTicket(detailTicket);
        let { listInitTickets, ticketsWithoutTourLineId } = this.state;
        const { allTourTicketsByIds = [] } = this.props.tourTicket;
        const allSelectedTourTicketItemIds = Object.keys(ticketItemIdsByTicket).reduce((ids, tourItemId) => ids.concat(ticketItemIdsByTicket[tourItemId]), []);

        Object.keys(ticketItemIdsByTicket).forEach(tourItemId => {
            const tourTicketItemIds = ticketItemIdsByTicket[tourItemId];
            const existedTicket = ticketsWithoutTourLineId.filter(item => {
                return item.tourTicket && item.tourTicket.id === tourItemId;
            });
            const tourTicketItems = [];
            const existedTourItem = allTourTicketsByIds.filter(item => {
                return item.id === tourItemId
            })
            if (existedTicket && existedTicket.length > 0 && existedTourItem && existedTourItem.length > 0) {
                const currentExistedData = existedTicket[0];
                const currentTourTicketItems = currentExistedData.tourTicketItems;
                const differenceIds = difference(tourTicketItemIds, listInitTickets);
                if (differenceIds && differenceIds.length > 0) {
                    differenceIds.map(item => {
                        const tourTicketItemsAll = existedTourItem[0].tourTicketItems;
                        const tourTicketItemById = tourTicketItemsAll.filter(tourTicketItem => {
                            return item === tourTicketItem.id;
                        })
                        if (tourTicketItemById && tourTicketItemById.length > 0) {
                            currentTourTicketItems.push(tourTicketItemById[0]);
                        }
                    })
                }
            } else {
                if (existedTourItem && existedTourItem.length > 0) {
                    const item = existedTourItem[0];
                    const itemTourTicketItems = item.tourTicketItems;
                    if (itemTourTicketItems && itemTourTicketItems.length > 0) {
                        tourTicketItemIds.map(item => {
                            const tourTicketItemById = itemTourTicketItems.filter(tourTicketItem => {
                                return item === tourTicketItem.id;
                            })
                            if (tourTicketItemById && tourTicketItemById.length > 0) {
                                tourTicketItems.push(tourTicketItemById[0]);
                            }
                        })
                    }
                    ticketsWithoutTourLineId.push({
                        tourTicket: {
                            id: tourItemId,
                            name: item.name,
                        },
                        tourTicketItems: tourTicketItems,
                    })
                }
            }
        })
        const newListInitTickets = [
            ...listInitTickets,
            ...allSelectedTourTicketItemIds
        ]
        this.setState({
            listInitTickets: uniq(newListInitTickets),
            ticketsWithoutTourLineId,
        })
        this.props.onInitTickets(uniq(newListInitTickets));
        this.closeModal();
    }

    // addInitTicket = (detailTicket) => {
    //     const { listInitTickets } = this.state;
    //     const filterListTicket = listInitTickets.filter(ticket => ticket.ticketId === detailTicket.ticketId);
    //     if (filterListTicket.length > 0) {
    //         message.error(this.props.t('validation.statusCode.code.EXISTED'));
    //         return false;
    //     }
    //     const newListInitTickets = [...listInitTickets, detailTicket];
    //     this.completeAction(newListInitTickets)
    // }
    //
    // updateInitTicket = (detailTicket) => {
    //     const { listInitTickets } = this.state;
    //     const filterListTicket = listInitTickets.filter(ticket => ticket.ticketId === detailTicket.ticketId);
    //     const newListInitTickets = [...listInitTickets];
    //     if (filterListTicket.length > 0 && newListInitTickets[this.state.iSelected].ticketId !== filterListTicket[0].ticketId) {
    //         message.error(this.props.t('validation.statusCode.code.EXISTED'));
    //         return false;
    //     }
    //     newListInitTickets[this.state.iSelected] = detailTicket;
    //     this.completeAction(newListInitTickets)
    // }

    // deleteInitTicket = (index) => {
    //     const { listInitTickets } = this.state;
    //     const newListInitTickets = [...listInitTickets];
    //     newListInitTickets.splice(index, 1);
    //     this.completeAction(newListInitTickets)
    // }

    // completeAction = (newListInitTickets) => {
    //     this.props.onInitTickets(newListInitTickets);
    //     this.setState({ listInitTickets: newListInitTickets });
    //     this.closeModal();
    // }

    closeModal = () => {
        this.resetDetail()
        this.setState({ openDetail: false, isEdit: false })
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option.props.children.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    }

    resetDetail = () => {
        const detailTicket = {
            tourItemId: null,
            tourItemIds: [],
            tourLineItemId: null,
            tourTicketItemIds: [],
        }
        this.setState({ detailTicket, listTourTicketItems: [] });
    }

}

export default withTranslation()(TourLineTicket)
